import React from 'react';

export const CollectionCard = ({
                                   collection,
                                   idx,
                                   isOpen,
                                   onToggle
                               }) => {
    return (
        <div key={idx} className="card cardshadow mb-6 relative">
            <div className={`ribbon ${
                collection.enforcementMode.toLowerCase() === 'enforced' ? 'bg-green' :
                    collection.enforcementMode.toLowerCase().includes('audit') ? 'bg-blue' :
                        'bg-gray'
            }`}>
                {collection.enforcementMode}
            </div>

            <div
                className="card-header flex justify-between items-center flex-nowrap cursor-pointer hover:bg-gray-50 transition"
                onClick={() => onToggle(idx)}
            >
                <div className="flex items-center space-x-2">
                    {collection.icon}
                    <span className={`badge ${collection.badgeClass} text-sm px-3 py-1 rounded font-semibold`}>
                        {collection.type}
                    </span>
                    <span className="badge bg-gray-100 text-gray-700 text-xs px-2 py-0.5 rounded">
                        {collection.content.length} rule{collection.content.length !== 1 ? 's' : ''}
                    </span>
                </div>
            </div>

            {isOpen && (
                <div className="ml-4 mt-3 p-3">
                    {collection.content}
                </div>
            )}
        </div>
    );
};